import React, { useState } from "react";
import ReactModal from "react-modal";
import Loading from "./Loading";
import { toast } from "react-toastify";
import { deleteGallery } from "../api/dashboardApi";

const GalleryItem = ({ item, setRefresh, user }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (user?.id) {
      setLoading(true);
      try {
        const data = {
          url: item?.image,
        };

        await deleteGallery(item?.id, data);

        toast.success("Gallery image deleted successfully");
        setModalIsOpen(false);
        setLoading(false);
        setRefresh((curr) => !curr);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  return (
    <>
      <ReactModal
        className="modalMain"
        overlayClassName="modal-overlayCenter"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Cart Modal"
      >
        <div className="tableMenu__modal">
          <h4 style={{ marginBottom: 10 }}>Are you sure</h4>
          <p>
            You are about to delete a gallery image, this process cannot be
            undone
          </p>
          <div className="tableMenu__modal__btn">
            <button
              className="tableMenu__modal__btn__item"
              onClick={() => setModalIsOpen(false)}
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="tableMenu__modal__btn__item delete"
            >
              {loading ? <Loading button={true} /> : "Delete"}
            </button>
          </div>
        </div>
      </ReactModal>
      <div className="blog__main__list__item">
        <img
          style={{ width: "100%", height: "auto" }}
          src={process.env.REACT_APP_API_URL + item?.image}
          alt=""
        />

        <div className="blog__main__list__item__action">
          {/* <Link to={"/dashboard/gallerys/edit/" + gallery?.id}>
            <i className="feather ft-edit"></i>
          </Link> */}
          <i className="ti-trash del" onClick={() => setModalIsOpen(true)}></i>
        </div>
      </div>
    </>
  );
};

export default GalleryItem;
